// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox_root__12pX6","input":"Checkbox_input__LQJ3Y","box":"Checkbox_box__iWJFB","label":"Checkbox_label__TRl4G","disabled":"Checkbox_disabled__2sYif"};